import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import isMobile from 'store/app/selector/isMobile';
import styles from './AddingProductSpinner.module.scss';
import ItemsLoadingSpinner from '../ItemsLoadingSpinner/ItemsLoadingSpinner';

const AddingProductSpinner = () => {
  const { t } = useTranslation();
  const isMobileDevice = useSelector(isMobile);

  const headerVariant = isMobileDevice ? 'title-large-bold' : 'headline-large-bold';
  const descriptionVariant = isMobileDevice ? 'label-large-regular' : 'title-medium-regular';

  return (
    <div className={styles.spinner}>
      <OpText variant={headerVariant}>{t('txt_bring_memories_back')}</OpText>
      <OpText variant={descriptionVariant} className={styles.description}>
        {t('txt_adding_product_wait')}
      </OpText>
      <OpText variant={descriptionVariant} className={styles.description}>
        {t('txt_please_wait')}
      </OpText>

      <ItemsLoadingSpinner />
    </div>
  );
};

export default AddingProductSpinner;
